import { useTranslation } from 'react-i18next';
import { RouterProvider } from 'react-router-dom';

import { ThemeProvider } from '@mui/material/styles';

import CssBaseline from '@mui/material/CssBaseline';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { Router } from '@/components/pages';

import i18n from './i18n';
import { baseTheme } from './theme';

function App() {
  return (
    <>
      <CssBaseline />
      <ThemeProvider theme={baseTheme}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <RouterProvider router={Router} />
        </LocalizationProvider>
      </ThemeProvider>
    </>
  );
}

export default App;
